/** @typedef	{import('./CopyEmbedCodeProps').default} Props */

import { translate } from '../../Internationalization';
import CopyToClipboard from '../../../shared/Links/CopyToClipboard';
import EmbedCode from './EmbedCode';
import EmbedFooter from './EmbedFooter';
import FormSuccessMessages from '../../../shared/Forms/Messages/FormSuccessMessages';
import LanguageOptions from './LanguageOptions';
import React, { useState } from 'react';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function CopyEmbedCode(props) {
	const [copySuccess, setCopySuccess] = useState(false);

	function successMsg() {
		if (!copySuccess) {
			return null;
		}

		return (
			<div className="[&>*]:m-0">
				<FormSuccessMessages
					messages={translate(
						'agent.pages.widgets.lead_generation.embed.copy_code_success_message'
					)}
				/>
			</div>
		);
	}

	return (
		<section className="flex flex-col gap-4 mt-6" id="embed">
			<h1 className="hl-ms-6">
				{translate(
					'agent.pages.widgets.lead_generation.embed.embed_code'
				)}
			</h1>

			<section className="flex flex-col gap-2 sm:w-2/3 md:w-1/2 outline outline-grey-300 outline-1 p-2 rounded-md">
				<p className="font-bold w-full">
					{translate(
						'agent.pages.widgets.lead_generation.embed.code_type_description'
					)}
				</p>

				<LanguageOptions
					codeType={props.codeType}
					isGettingData={props.isGettingData}
					onTypeUpdate={props.onTypeUpdate}
				/>

				<EmbedCode
					code={props.code}
					isGettingData={props.isGettingData}
				/>

				<CopyToClipboard
					className="button w-full"
					onSuccess={() => setCopySuccess(true)}
					text={translate(
						'agent.pages.widgets.lead_generation.embed.copy_code'
					)}
					url={props.code}
				/>

				{successMsg()}
			</section>

			<EmbedFooter />
		</section>
	);
}

export default React.memo(CopyEmbedCode);
